const Donaciones = () => {
  const donationOptions = [
    { amount: 100, url: "https://mpago.la/2itGavs" },
    { amount: 300, url: "https://mpago.la/2W7dYqA" },
    { amount: 500, url: "https://mpago.la/2Em5Rtg" },
  ];

  return (
    <div className="h-full flex flex-col items-center text-center p-4">
      <h2 className="text-3xl font-main font-medium mb-4">Apoya Nuestro Trabajo</h2>
      <p className="text-gray-600 font-main mb-8 max-w-md">
        Tu donación nos ayuda a mantener la plataforma en funcionamiento,
        mejorar nuestras herramientas y seguir conectando a mascotas perdidas
        con sus familias. ¡Cada contribución cuenta!
      </p>
      <div className="flex flex-col sm:flex-row gap-6 sm:flex-col">
        {donationOptions.map((option) => (
          <a
            key={option.amount}
            href={option.url}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-secondary w-[250px] hover:bg-orange-700 text-white text-2xl  font-main py-4 px-8 rounded-lg shadow-lg transition-transform transform hover:scale-105"
          >
            Donar ${option.amount}
          </a>
        ))}
      </div>
      <div className="mt-12 ">
        <h3 className="text-3xl font-main font-medium mb-4">¿Quieres saber más?</h3>
        <p className="text-gray-600 font-main mb-4">
          Descubre la historia detrás de BuscaTuAmigo y conoce al equipo que lo
          hace posible.
        </p>
        <a
          href="/quienes-somos"
          className="bg-secondary hover:bg-orange-700 text-white font-main text-2xl py-3 px-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 inline-block"
        >
          Saber más
        </a>
      </div>
    </div>
  );
};

export default Donaciones;
